<template>
  <div class="emotions">
    <a
      :class="['emotions__label']"
    >
      <span class="label-info">{{$tr('vacancy.voiceBot.emotion.title')}}:</span>
      <img :src="mainEmotion.img" />
      <span>{{ mainEmotionLabel }}</span>
      <div class="emotions__arrow" />
    </a>
    <div class="popover-wrapper">
      <transition name="fade">
        <div class="emotions__popover" v-if="isPopovedVisible">
          <div class="emotions__popover-content">
            <ul class="emotions__list">
              <li
                v-for="(emotion, index) in emotionsFirstList"
                :key="index"
                class="emotions__emotion-item"
              >
                <img :src="emotion.img" />
                <span class="item-name">{{ $tr('vacancy.voiceBot.emotion.emotions.' + emotion.name) }}</span>
                <div class="item-value-wrapper">
                  <span class="item-value">{{ emotion.value + '%' }}</span>
                </div>
              </li>
            </ul>
            <ul class="emotions__list">
              <li
                v-for="(emotion, index) in emotionsSecondList"
                :key="index"
                class="emotions__emotion-item"
              >
                <img :src="emotion.img" />
                <span class="item-name">{{ $tr('vacancy.voiceBot.emotion.emotions.' + emotion.name) }}</span>
                <div class="item-value-wrapper">
                  <span class="item-value">{{ emotion.value + '%' }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import emotions from '../emotions'

export default {
  mixins: [emotions],

  props: {
    video: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    isPopovedVisible: true
  }),

  computed: {
    emotions () {
      return this.calcEmotions(this.video.emotions)
        .filter(item => item.value !== null)
    },

    emotionsFirstList() {
      if (!this.emotions || !this.emotions.length) {
        return [];
      }

      return this.emotions.filter((item, index) => index <= 3);
    },

    emotionsSecondList() {
      if (!this.emotions || !this.emotions.length) {
        return [];
      }

      return this.emotions.filter((item, index) => index >= 4);
    },

    mainEmotion () {
      return this.calcMainEmotion(this.video.emotions)
    },

    mainEmotionLabel () {
      const emotion = this.$tr('vacancy.voiceBot.emotion.emotions.' + this.mainEmotion.name)

      return emotion;
    }
  },

  methods: {
    handleTogglePopover() {
      this.isPopovedVisible = !this.isPopovedVisible
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../styles/colors.scss";

  .emotions {
    position: relative;
    // font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.005em;
    color: #233346;

    .popover-wrapper {
      display: none;
    }

    &:hover {
      .emotions__arrow {
        transform: rotate(0deg) !important;
      }

      .popover-wrapper {
        display: block;
      }
    }

    &__label {
      display: flex;
      align-items: center;
      white-space: nowrap;
      cursor: pointer;
      color: #555;

      &:hover,
      &:focus,
      &:active,
      &.active {
        color: #233346;
        outline: none;
      }

      img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
    }

    &__arrow {
      margin-left: 7px;
      width: 10px;
      height: 10px;
      background: url(/static/images/elements/caret-up.svg) no-repeat center;
      transition: transform .3s;
      transform: rotate(180deg);

      .active & {
        transform: rotate(0deg);
      }

      @media (max-width: 800px) {
        display: none;
      }
    }

    &__popover {
      border: 1px solid #D2D6E0;
      box-sizing: border-box;
      border-radius: 2px;
      height: 120px;
      padding: 15px 20px;
      position: absolute;
      top: 27px;
      background: $white-color;
      z-index: 1;

      @media (max-width: 800px) {
        display: none;
      }

      &-content {
        display: flex;
        flex-wrap: nowrap;
        align-items: stretch;
        justify-content: space-between;
        width: 100%;
      }
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      width: 100%;
      align-items: stretch;
      box-sizing: border-box;
      padding: 0;
      list-style-type: none;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }

    &__emotion-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0;

      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        margin-left: auto;
      }

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }

    .item-value-wrapper {
      margin-left: auto;
      width: 37px;
    }

    .item-name {
      margin-right: 14px;
      white-space: nowrap;
    }
  }

  .label-info {
    margin-right: 8px;
  }
</style>
